import { useSyncExternalStore } from 'react';
import { getBestAssetUrl, subscribeToPngUpgrades } from '../services/assets';

export function useAsset(key: string): string {
  return useSyncExternalStore(subscribeToPngUpgrades, () => getBestAssetUrl(key), () => getBestAssetUrl(key));
}
